(function () {
  if (window.kkpFilmReady) return;
  window.kkpFilmReady = true;

  function openFilm(dialog) {
    var player = dialog.querySelector('.kkp-film__player');
    var template = dialog.querySelector('template');
    if (player && template && !player.firstElementChild) {
      player.appendChild(template.content.cloneNode(true));
    }

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('kkp-film-open');

    var video = player && player.querySelector('video');
    if (video) {
      video.currentTime = 0;
      var playing = video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(function () {});
    }
  }

  function stopFilm(dialog) {
    var player = dialog.querySelector('.kkp-film__player');
    var video = player && player.querySelector('video');
    if (video) video.pause();
    // Removing the iframe is the only reliable way to stop YouTube/Vimeo audio.
    if (player && player.querySelector('iframe')) player.innerHTML = '';
    document.documentElement.classList.remove('kkp-film-open');
  }

  function closeFilm(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else {
      dialog.removeAttribute('open');
      stopFilm(dialog);
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-kkp-film-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('aria-controls'));
      if (target) {
        event.preventDefault();
        openFilm(target);
      }
      return;
    }

    var closer = event.target.closest('[data-kkp-film-close]');
    if (closer) {
      closeFilm(closer.closest('dialog'));
      return;
    }

    if (event.target.classList && event.target.classList.contains('kkp-film')) {
      closeFilm(event.target);
    }
  });

  document.addEventListener(
    'close',
    function (event) {
      if (event.target.classList && event.target.classList.contains('kkp-film')) stopFilm(event.target);
    },
    true
  );
})();
